//var domui = require('@webhare-system/internal/legacyui');
import * as dompack from 'dompack';
import ScrollMonitor from 'dompack/extra/scrollmonitor';
import { /*qS, */qSA } from 'dompack/extra/qsa';
//var domtools = require('@webhare-system/dom/tools');
//var domfocus = require('@webhare-system/dom/focus');
var WHBase = require('@webhare-system/compat/base');
var url = require('@webhare-system/internal/url');
var legacybase = require('@webhare-system/internal/legacybase');
//const Promise = require('@webhare-system/compat/promise');

import { $, $$, Element, Events, Options, Class } from "@webhare-system/frameworks/mootools/core";

require('@webhare-publisher/richcontent/styling.css');
require('@webhare-system/frameworks/mootools/core');
var StructuredEditor = require('./internal/structurededitor');
var FreeEditor = require('./internal/freeeditor');
var TableEditor = require('./internal/tableeditor');
var Toolbar = require('./internal/toolbar');
import './richeditor.scss';
var SelectionInterface = require('./internal/selection');
//var JSONRPC = require('@webhare-system/net/jsonrpc');
import { convertHtmlToPlainText } from "@webhare-system/internal/converthtmltoplaintext";


/** Frame manager for current document (self equivalent of PersistentIframe)
*/
var SelfFrameManager = new Class(
{ Implements: [ Events, Options ]

  // ---------------------------------------------------------------------------
  //
  // Variables
  //

  /// Root element of page area
, elt: null

  /// SelectionInterface object for this.elt
, selectionitf: null

  // ---------------------------------------------------------------------------
  //
  // Initialize
  //

, initialize: function(elt, options)
  {
    this.setOptions(options);
    this.elt = elt;
    this.selectionitf = new SelectionInterface(this.elt);
    this.elt.addEventListener('mousedown', this._gotMouseDown.bind(this));
  }

  // ---------------------------------------------------------------------------
  //
  // Callbacks
  //

, _gotMouseDown: function(event)
  {
    this.fireEvent('mousedown', { target: event.target });
  }

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

    /// Return the frame object
, getFrame: function()
  {
    return null;
  }

  /// Return the document object
, getDoc:function()
  {
    return $(this.elt.ownerDocument);
  }

  /// Return the body node
, getBody:function()
  {
    return this.elt;
  }

  /// Return the head node
, getHead:function()
  {
    return null;
  }

, getElementById:function(id)
  {
    return document.getElementById(id);
  }

, getElementsByTagName:function(tag)
  {
    return this.getBody().getElementsByTagName(tag);
  }

, toElement: function()
  {
    return this.elt;
  }

, getBodyHTML:function()
  {
    return this.elt.innerHTML;
  }

, setBodyHTML:function(newhtml)
  {
    this.elt.innerHTML = newhtml;
  }

, hasFocus: function()
  {
    var active = legacybase.getActiveElement(document);
    while (active && active != this.elt)
      active = active.parentNode;
    return !!active;
  }

  /// Returns raw selection range (for use in tests)
, debugGetRawSelectionRange: function()
  {
    return this.selectionitf.getSelectionRange();
  }

, isLoaded: function()
  {
    return true;
  }
});

var RTE = new Class(
{ /*Extends: $wh.PreloadableAsset
, */Implements: [Events,Options]

  // ---------------------------------------------------------------------------
  //
  // Variables
  //

, container:null
, options: { structure: null
           , allowtags: null
           , hidebuttons: []
           , content: ''
           , enabled: true
           , readonly: false
           , log: false
           , selfedit: false
           , pageedit: false
           //, actionhandler: null
           , actionelements: []
           , cssinstance: null
           , csslinks:null
           , csscode:''
           , breakupnodes: []
           , htmlclass: ''
           , bodyclass: ''

           , contentarea: true //display a content area if possible
           , editembeddedobjects: true
           }
, toolbar: null
, editable: false
, editnode: null
, editrte: null
//, iframe:null

, htmldiv: null
, bodydiv: null

, showformatting: false

, cachededitors: []

, editoridcounter: 0
, editors: {}
, addcss: []

, pageframe: null

  /// Whether document is dirty. Initial set to true to avoid firing events during init
, dirty: true
, original_value: "<neverset>"
  //URLs of images we have already seen and stored on the server
, knownimages: []

  // ---------------------------------------------------------------------------
  //
  // Init
  //

, initialize:function(container, options)
  {
    this.setOptions(options);
    if(options && options.toolbarnode)
      this.toolbarnode = $(options.toolbarnode);

    this.container = container;
    if(this.container.whRTD)
      throw new Error("Duplicate RTD initialization");

    this.container.store('wh-rtd', this);
    this.container.whRTD = this;

    if(WHBase.debug.rte)
      console.log("[rte] initializing rtd",this.container, this.options);

    if (!this.options.selfedit)
    {
      this.toolbarnode = dompack.create("div");
      //the 'style scope' node is the point from which we apply the rewritten css. it needs to be the immediate parent of the wh-rtd__html node
      this.stylescopenode = dompack.create("div", { className: "wh-rtd__stylescope " + (this.options.cssinstance || '') });

      //ADDME globally manage css loaded by instances
      if(this.options.csslinks)
        this.options.csslinks.each(function(href)
        {
          if(href)
          {
            href = new url.URL(location.href).resolveToAbsoluteURL(href);
            this.addcss.push({type:"link",src:href});
          }
        }.bind(this));

      if(this.options.csscode)
        this.addcss.push({type:"style",src:this.options.csscode});

      //Create two divs inside the container, which will play the role of HTML and BODY
      this.bodydiv = dompack.create("div", { className: "wh-rtd-editor wh-rtd__body wh-rtd-editor-bodynode " + this.options.bodyclass
                                           , innerHTML : this.container.innerHTML
                                           , on: { "dompack:takefocus": evt => this._takeSafeFocus(evt) }
                                           });
      this.htmldiv = dompack.create("div", { className: "wh-rtd-editor wh-rtd__html wh-rtd-editor-htmlnode " + this.options.htmlclass
                                           , childNodes: [ this.bodydiv]
                                           });

      this.container.empty();
      this.container.classList.add("wh-rtd__editor");
      this.container.appendChild(this.toolbarnode);

      this.stylescopenode.appendChild(this.htmldiv);
      this.container.appendChild(this.stylescopenode);

      this.htmldiv.addEventListener("mousedown", this._gotPageClick.bind(this)); //FIXME do we need this if we properly stretch <html> node ? we still need it for page editor

      this.pageframe = new SelfFrameManager(this.bodydiv);
      this.scrollmonitor = new ScrollMonitor(this.container);
      ScrollMonitor.saveScrollPosition(this.container);
    }
    else
    {
      this.pageframe = new SelfFrameManager(container,
                                                { onMousedown: this._gotPageClick.bind(this)
                                                });
    }

    if(this.toolbarnode)
    {
      var toolbaropts = { hidebuttons: this.options.hidebuttons
                        , allowtags: this.options.allowtags
                        };

      if(this.options.structure)
      {
        toolbaropts.hidebuttons.append(['action-clearformatting']);
      }
      else
      {
        toolbaropts.hidebuttons.append(['p-class','action-showformatting','object-insert','object-video','table']);
        toolbaropts.compact = true;
      }
      if(!(this.options.structure && this.options.structure.anchors))
        toolbaropts.hidebuttons.append(['p-id']);

      this.toolbarnode.classList.add("wh-rtd-toolbar");
      this.toolbar = new Toolbar(this, this.toolbarnode, toolbaropts);

      if (this.options.readonly)
        this.toolbarnode.setStyle("display", "none");
    }

    this.gotPageFrameLoad();

    RTE.register(this);
    this.clearDirty();
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions
  //

, _takeSafeFocus:function(evt)
  {
    //TODO? An alternative approach might be to have the ScrollMonitor watch focus events ?
    //take focus but save scroll position  (ADDME for non-body nodes too!)
    evt.preventDefault();

    let scrollleft = evt.target.parentNode.scrollLeft;
    let scrolltop = evt.target.parentNode.scrollTop;

    evt.target.focus(); //on chrome, focus resets scroll position. https://bugs.chromium.org/p/chromium/issues/detail?id=75072

    evt.target.parentNode.scrollLeft = scrollleft;
    evt.target.parentNode.scrollTop = scrolltop;
  }

  //get the current dirty flag
, isDirty:function()
  {
    return this.dirty;
  }
  //clear dirty state
, clearDirty:function()
  {
    this.original_value = this.getValue();
    this.dirty = false;
  }

, _checkDirty: function()
  {
    if (this.dirty)
      return;

    this.dirty = this.original_value != this.getValue();
    if (this.dirty)
    {
      if (WHBase.debug.rte)
        console.log("[rte] Document got dirty, firing event");

      legacybase.dispatchDomEvent(this.container, "wh-rtd-dirty",
                         { bubbles: true
                         , cancelable: true
                         , detail: { target: this }
                         });
    }
  }

, getEditNode:function(node)
  {
    if(!this.options.pageedit && !this.options.selfedit)
      return this.basenode;

    for(;node &&node != this.basenode; node = node.parentNode)
    {
      if (!node.getAttribute)
        continue;

      if (node.hasAttribute('whrtd-edit'))
        return node;

      // Also pick up tableeditor resize handlers, redirect them to table node
      if (node.hasClass('wh-tableeditor-resize-holder'))
        node = node.retrieve('wh-tableeditor').node;
    }
    return null;
  }

, createEditor:function(edittarget)
  {
    var editoropts = { log: this.options.log
                     , designmode: false
                     , eventnode: this.container
                     , actionelements: this.options.actionelements.append(
                            [ { element:"img" }
                            , { element:"a",   hasattributes: ["href"] }
                            , { element:"div", hasattributes: ["data-instanceref"] }
                            , { element:"table", hasclasses: ["wh-rtd__table"] }
                            ])
                     , breakupnodes: this.options.breakupnodes
                     , editembeddedobjects: this.options.editembeddedobjects
                     , allowundo: !!this.options.undoholder
                     };

    var editor;
    if(this.options.structure)
    {
      var undonode = null;
      if (this.options.undoholder)
      {
        editoropts.allowundo = true;
        undonode = new Element('div', { contentEditable: true, style: 'opacity: 0.1;' });
        this.options.undoholder.adopt(undonode);
      }

      editoropts.structure = this.options.structure; //FIXME limit structure to what is needed here
      editor = new StructuredEditor(edittarget,  this, editoropts, undonode, this.pageframe);
    }
    else
    {
      editoropts.allowtags = this.options.allowtags;
      editoropts.edittables = this.options.edittables;
      editor = new FreeEditor(edittarget, this, editoropts, this.pageframe);
    }

    editor.setShowFormatting(this.showformatting);
    return editor;
  }
/*
, startEditor:function(edittarget)
  {
    //does our iframe have focus? (ADDME how will this work for 'self' mode?)
   var hadfocus = this.pageframe.hasFocus();

    if(this.editnode == edittarget)
      return true; //ignore clicks on the active RTE

    this.stopEditor();
    if(!edittarget)
      return false;

    var editor;
    if(!edittarget._wh_editorid)
    {
      editor = this.createEditor(edittarget);
      this.cachededitors.push(editor);
      edittarget._wh_editorid = this.cachededitors.length;
    }
    else
    {
      editor=this.cachededitors[edittarget._wh_editorid-1];
      editor.setEnabled(true);
    }

    //launch an editor!
    this.editnode = edittarget;
    this.editrte = editor;

    if(this.toolbar)
      this.toolbar.setEditor(this.editrte);
    this.basenode.classList.add("-wh-rtd-editing");

    if(hadfocus)
      this.editrte.takeFocus();

    this.fireEvent("editorchange", {target:this, editor:this.editrte});
  }

, stopEditor:function()
  {
    if(!this.editnode)
      return;

    this.editnode=null;
    this.editrte.setEnabled(false);
    this.editrte=null;

    this.fireEvent("editorchange", {target:this, editor:null});
    this.basenode.classList.remove("-wh-rtd-editing");

    //this.fireEvent("statechange"); //who is using this?

    if(this.toolbar)
      this.toolbar.setEditor(null);
  }
*/
, connectEditor: function(editnode)
  {
    if(WHBase.debug.rte)
      console.log("[rte] connecting editor",editnode, editnode.wh_editor_id);
    if (!editnode.wh_editor_id)
    {
      editnode.wh_editor_id = ++this.editoridcounter;
      this.editors[editnode.wh_editor_id] = this.createEditor(editnode);
    }

    this.disconnectCurrentEditor();

    this.editnode = editnode;
    this.editrte = this.editors[editnode.wh_editor_id];

    this.editrte.editareaconnect();
    this.basenode.classList.add("wh-rtd-editing");
    this.editrte.onstatechange = this.gotStateChange.bind(this);
    this.editrte.onprepaste = this.gotPrePaste.bind(this);

    this.fireEvent("editorchange", {target:this, editor:this.editrte});

    this.editable = true;
  }

, disconnectCurrentEditor: function()
  {
    if (this.editrte)
    {
      this.editrte.onstatechange = null;
      this.editrte.onprepaste = null;

      this.editrte.editareadisconnect();
      this.basenode.classList.remove("wh-rtd-editing");

      this.fireEvent("editorchange", {target:this, editor:null});
      this.editrte.destroy();
    }

    this.editnode = null;
    this.editrte = null;

    this.editable = false;
  }

  // ---------------------------------------------------------------------------
  //
  // Callbacks
  //

, _gotPageClick: function(event)
  {
    if (!this.options.enabled || this.options.readonly)
      return;

    let editnode = this.getEditNode(event.target);
    if (this.editnode != editnode)
    {
      if (this.editnode)
        this.disconnectCurrentEditor();
      if (editnode)
        this.connectEditor(editnode);
      this.fireEvent("statechange", { target: this });
    }
    else if (editnode)
    {
      let lastelt = editnode.lastElementChild;
      console.log(lastelt, event.clientY, lastelt && lastelt.getBoundingClientRect().bottom);
      if (!lastelt || event.clientY > lastelt.getBoundingClientRect().bottom)
        this.editrte.requireBottomParagraph();
    }

    // clicked on the html-div?
    if (this.editnode && this.editnode.parentNode === event.target)
    {
      // focus body node instead
      this.editnode.focus();
      event.preventDefault();
    }
  }

, gotPageFrameLoad:function()
  {
    this.basenode = this.getBody();
    this.basenode.classList.add("wh-rtd");
    this.basenode.classList.add("wh-rtd-editor");
    this.basenode.classList.add("wh-rtd-theme-default");
    this.basenode.toggleClass('wh-rtd-disabled', !this.options.enabled);
    this.basenode.toggleClass('wh-rtd-readonly', this.options.readonly);

    if(this.options.structure && this.options.structure.contentareawidth && this.pageframe)
    {
      if(this.options.contentarea)
      {
        this.basenode.parentNode.classList.add('wh-rtd-withcontentarea');
        this.basenode.classList.add('wh-rtd__body--contentarea');
      }
      this.basenode.setStyle("width", this.options.structure.contentareawidth);
    }

    if (!this.options.enabled || this.options.readonly)
    {
      //this.donePreload(true);
      this.fireEvent("statechange", { target: this });
      return;
    }

    if (!this.options.selfedit && !this.options.pageedit)
      this.connectEditor(this.pageframe.getBody());

    this.fireEvent("editable", { target: this });
    this.fireEvent("statechange", { target: this });
  }

, gotStateChange: function(event)
  {
    this.fireEvent('statechange', { target: this });
    this._checkDirty();
  }
, gotPrePaste: function(event)
  {
    this.fireEvent('prepaste', event);
  }

  // ---------------------------------------------------------------------------
  //
  // Action and content API
  //
, insertHyperlink: function(link, options)
  {
    this.editrte.insertHyperlink(link,options);
    this._checkDirty();

  }

, getTargetInfo: function(actiontarget) //provide JSON-safe information about the action target
  {
    if(!actiontarget)
      return null; //not all our events support actiontargets yet, so expect undefined/null

    let node = actiontarget.__node;

    switch (node.nodeName.toUpperCase())
    {
      case "A":
      {
        return { type: 'hyperlink'
               , link: node.getAttribute("href") //note that getAttribute gives the 'true' link but 'href' may give a resolved link
               , target: node.target || ''
               };
      }
    }
    return null;
  }
, updateTarget: function(actiontarget, settings)
  {
    if(actiontarget.__node && actiontarget.__node.nodeName=='A')
      return this.updateHyperlink(actiontarget, settings);
    throw new Error("Did not understand action target");
  }
, updateHyperlink: function(actiontarget, settings)
  {
    if(actiontarget.__node.nodeName != 'A')
      throw new Error("Action target is not a hyperlink");

    if(settings.destroy) //get rid of the hyperlink
    {
      this.editrte.selectNodeOuter(actiontarget.__node);
      this.editrte.removeHyperlink();
      this._checkDirty();
      return;
    }

    if('link' in settings)
      actiontarget.__node.setAttribute("href",settings.link);
    if('target' in settings)
      if(settings.target)
        actiontarget.__node.target = settings.target;
      else
        actiontarget.__node.removeAttribute('target');

    this._checkDirty();
  }

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

, destroy:function()
  {
    this.disconnectCurrentEditor();
    this.cachededitors.each(function (editor) { editor.destroy(); });
    this.toolbarnode.dispose();
    this.container.eliminate("wh-rtd");
    RTE.unregister(this);
  }

, getBody:function()
  {
    return this.bodydiv || this.container;
  }

, qS:function(selector)
  {
    return this.getBody().querySelector(selector);
  }

, qSA:function(selector)
  {
    return Array.from(this.getBody().querySelectorAll(selector));
  }

, getButtonNode:function(actionname)
  {
    return this.toolbarnode.querySelector('span.wh-rtd-button[data-button=' + actionname + ']');
  }

, getElement:function(selector)
  {
    return this.getBody().getElement(selector);
  }

, getElements:function(selector)
  {
    return this.getBody().getElements(selector);
  }

, isEditable:function()
  {
    return this.editable;
  }

, getEditor:function()
  {
    if(this.editrte)
      return this.editrte;
    return null;
  }

, getValue:function()
  {
    var returntree = this.getBody().cloneNode(true);

    //clean embedded objects
    $(returntree).getElements('div[class="wh-rtd-embeddedobject"]').each(function(node)
    {
      node.contentEditable="inherit";
      node.empty();
    });

    //clean table editors
    TableEditor.cleanupTree(returntree);

    $(returntree).getElements("*[tabindex]|*[todd-savedtabindex]").each(function(item)
    {
      item.removeAttribute("tabindex");
      item.removeAttribute("todd-savedtabindex");
    });

    return returntree.innerHTML;
  }

, setValue:function(val)
  {
    this.dirty = true;

    this.pageframe.setBodyHTML(val);
    this.knownimages = qSA(this.pageframe.getBody(), 'img').map(node => node.src);

    if(this.getEditor())
      this.getEditor().reprocessAfterExternalSet();

    this.original_value = this.getValue();
    this.dirty = false;

    this._checkDirty();
  }

, getActionTarget:function(actiontarget)
  {
    if (!this.getEditor())
      return null;
    return this.getEditor().getActionTarget(actiontarget); //ADDME this is probably unsafe if we switched editors in a PageEdit while processing the action, add tests
  }

, focus:function()
  {
    if(this.editrte)
      this.editrte.editelement.focus();
  }

, takeFocus: function()
  {
    if (this.editrte)
      this.editrte.takeFocus();
  }

, getSelectionState: function()
  {
    return this.editrte && this.editrte.getSelectionState();
  }

, getShowFormatting: function()
  {
    return this.showformatting;
  }

, setShowFormatting: function(newshowformatting)
  {
    this.showformatting = newshowformatting;
    Object.each(this.editors, function(editor) { editor.setShowFormatting(newshowformatting); });
  }

, getAvailableBlockStyles: function(selstate)
  {
    return this.editrte ? this.editrte.getAvailableBlockStyles(selstate) : [];
  }

, executeAction: function(action)
  {
    //FIXME: RTE should handle the action and dispatch to the active editor, so it can handle global rte actions (like show
    //       formatting)
    this.editrte && this.editrte.executeAction(action);
  }

, setSelectionBlockStyle: function(newblockstyle, forced)
  {
    this.editrte && this.editrte.setSelectionBlockStyle(newblockstyle, forced);
  }

, setEnabled: function(enabled)
  {
    if (enabled == this.options.enabled)
      return;

    this.options.enabled = enabled;

    if (this.basenode)
      this.basenode.toggleClass('wh-rtd-disabled', !this.options.enabled);

    if (this.options.readonly) // Readonly still active, no change
      return;

    if (enabled)
    {
      this.fireEvent("statechange");
      if (!this.options.selfedit && !this.options.pageedit)
        this.connectEditor(this.pageframe.getBody());
    }
    else
    {
      this.disconnectCurrentEditor();
      this.fireEvent("statechange");
    }
  }

, setReadonly: function(readonly)
  {
    if (readonly == this.options.readonly)
      return;

    this.options.readonly = readonly;

    if (this.toolbarnode)
      this.toolbarnode.setStyle('display', readonly ? "none" : "block");

    this.basenode.toggleClass('wh-rtd-readonly', this.options.readonly);

    if (!this.options.enabled) // Readonly still active, no change in editability
      return;

    if (!readonly)
    {
      this.fireEvent("statechange");
      if (!this.options.selfedit && !this.options.pageedit)
        this.connectEditor(this.pageframe.getBody());
    }
    else
    {
      this.disconnectCurrentEditor();
      this.fireEvent("statechange");
    }
  }

, setHTMLClass: function(htmlclass)
  {
    this.__replaceClasses(this.htmldiv, this.options.htmlclass, htmlclass);
    this.options.htmlclass = htmlclass;
  }

, setBodyClass: function(bodyclass)
  {
    this.__replaceClasses(this.bodydiv, this.options.bodyclass, bodyclass);
    this.options.bodyclass = bodyclass;
  }

, __replaceClasses: function(node, removeclass, addclass)
  {
    removeclass = removeclass.trim();
    addclass = addclass.trim();

    if (removeclass != "")
    {
      // remove old classes (to keep extra classes set later intact)
      for (let cname of removeclass.split(" "))
      {
        if (cname != "")
          node.classList.remove(cname);
      }
    }

    if (addclass != "")
    {
      for (let cname of addclass.split(" "))
      {
        if (cname != "")
          node.classList.add(cname);
      }
    }
  }

, getPlainText: function(method)
  {
    switch (method)
    {
      case "converthtmltoplaintext":
      {
        return convertHtmlToPlainText(this.bodydiv);
      }
    }
    throw new Error("Unsupported method for plaintext conversion: " + method);
  }
});
RTE.extend(
{ _active_rtes:  []
, addedcss: []

, findCSSRule:function(addcss)
  {
    for (var i = 0; i < RTE.addedcss.length; ++i)
      if(RTE.addedcss[i].type == addcss.type && RTE.addedcss[i].src == addcss.src)
        return RTE.addedcss[i];

    return null;
  }

  /// Register this RTE in the list of active RTE's
, register: function(rte)
  {
    if (WHBase.debug.rte)
      console.log('[wh.rich] Register new rte');

    RTE._active_rtes.include(rte);

    //Add any missing stylesheets
    for (var i = 0; i < rte.addcss.length;++i)
    {
      let rule = this.findCSSRule(rte.addcss[i]);
      if(rule)
      {
        rule.rtes.push(rte);
      }
      else
      {
        var node;
        if(rte.addcss[i].type == 'link')
        {
          node = new Element("link", { href: rte.addcss[i].src
                                     , rel: "stylesheet"
                                     , "data-wh-rtd-tempstyle": ""
                                     });
          $$('head').pick().adopt(node);
        }
        else
        {
          node = new Element("style", { type: "text/css"
                                        , "data-wh-rtd-tempstyle": ""
                                        });
          $$('head').pick().adopt(node); // give IE8 a chance to create the styleSheet node
          try
          {
            node.innerHTML = rte.addcss[i].src;
          }
          catch(e)//IE
          {
            node.styleSheet.cssText = rte.addcss[i].src;
          }

        }
        rule = { type: rte.addcss[i].type
               , src: rte.addcss[i].src
               , node: node
               , rtes: [rte]
               };
        RTE.addedcss.push(rule);
      }
    }
  }

  /// Unregister this RTE
, unregister: function(rte)
  {
    if (WHBase.debug.rte)
      console.log('[wh.rich] Unregister new rte');

    RTE._active_rtes.erase(rte);

    for (var i = rte.addcss.length - 1; i>=0; --i)
    {
      console.log(rte.addcss[i], rule);
      var rule = this.findCSSRule(rte.addcss[i]);
      if(rule)
      {
        rule.rtes.erase(rte);
        if(!rule.rtes.length)
        {
          rule.node.dispose();
          rte.addcss.splice(i,1);
        }
      }
    }
  }
});

RTE.getForNode = function(node)
{
  return node.whRTD || null;
};

module.exports = RTE;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/components/richeditor/index.es